import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from '~spa/Components/Link/Link';
import Header from './Header';
import './styles.scss';

const HeaderLink = ({
    title,
    isFavouriteSport = false,
    titleIconClassName = '',
    onClick,
    link,
    gtmAttribute,
    wrapperClass = 'widget-container-header',
    setSeeAllRef = undefined,
}) => {
    const titleIconClass = classNames({
        [`${wrapperClass}__icon ${wrapperClass}__icon-${titleIconClassName}`]:
            titleIconClassName,
    });
    const seeAllTitleLinkClass = `${wrapperClass}__see-all-title--link`;

    return (
        <div className={`${wrapperClass}__title ${titleIconClass}`}>
            {link ? (
                <Link
                    className={`${seeAllTitleLinkClass}`}
                    to={link}
                    onClick={onClick}
                    gtmAttribute={`${gtmAttribute}`}
                >
                    <Header
                        title={title}
                        titleIconClassName={titleIconClassName}
                        link={link}
                        isFavouriteSport={isFavouriteSport}
                        wrapperClass={wrapperClass}
                        setSeeAllRef={setSeeAllRef}
                    />
                </Link>
            ) : (
                <Header
                    title={title}
                    titleIconClassName={titleIconClassName}
                    link={link}
                    isFavouriteSport={isFavouriteSport}
                    wrapperClass={wrapperClass}
                    setSeeAllRef={setSeeAllRef}
                />
            )}
        </div>
    );
};

HeaderLink.propTypes = {
    title: PropTypes.string.isRequired,
    titleIconClassName: PropTypes.string,
    isFavouriteSport: PropTypes.bool,
    link: PropTypes.string,
    wrapperClass: PropTypes.string,
    onClick: PropTypes.func,
    gtmAttribute: PropTypes.string,
    setSeeAllRef: PropTypes.func,
};

export default HeaderLink;
